import script from "./VendorDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetailView.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetailView.vue?vue&type=style&index=0&id=34f4dc25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f4dc25"]])

export default __exports__